import { Grid, Typography, Chip, Box, Button } from "@mui/material";
import { StatBox } from "./styled";
import {
  People as PeopleIcon,
  TrendingUp as TrendingIcon,
  Warning as WarningIcon,
  Event as EventIcon,
  OpenInNew as OpenInNewIcon,
} from "@mui/icons-material";

const BatchStats = ({ batch }) => (
  <>
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <StatBox>
          <TrendingIcon color="success" sx={{ mr: 1, fontSize: "15px" }} />
          <Typography variant="h2" sx={{ fontSize: "0.8rem", fontWeight: 700 }}>
            {batch.available_count} Available
          </Typography>
        </StatBox>
      </Grid>
      <Grid item xs={6}>
        <StatBox>
          <PeopleIcon color="info" sx={{ mr: 1, fontSize: "15px" }} />
          <Typography variant="h3" sx={{ fontSize: "0.8rem", fontWeight: 700 }}>
            {batch.demandingCount} Demanding
          </Typography>
        </StatBox>
      </Grid>
      <Grid item xs={6}>
        <StatBox>
          <WarningIcon color="error" sx={{ mr: 1, fontSize: "15px" }} />
          <Typography variant="h3" sx={{ fontSize: "0.8rem", fontWeight: 700 }}>
            {batch.deficiate_count} Deficit
          </Typography>
        </StatBox>
      </Grid>
      <Grid item xs={6}>
        <StatBox>
          <EventIcon color="action" sx={{ mr: 1, fontSize: "15px" }} />
          <Typography variant="h3" sx={{ fontSize: "0.8rem", fontWeight: 700 }}>
            Total Exhibitors: {batch.exhibitors_count}
          </Typography>
        </StatBox>
      </Grid>
    </Grid>

    {/* Google Sheet Link (if active) */}
    {batch.google_sheet_url && (
      <Box
        sx={{
          mt: 1.5,
          p: 1,
          display: "flex",
          alignItems: "center",
          gap: 1,
          borderRadius: 1,
          bgcolor: "rgba(76, 175, 80, 0.08)",
          border: "1px solid rgba(76, 175, 80, 0.3)",
        }}
      >
        <Chip
          label="Live Syncing"
          size="small"
          color="success"
          variant="outlined"
          sx={{ fontWeight: 600, fontSize: "0.7rem" }}
        />
        <Button
          size="small"
          variant="text"
          color="success"
          endIcon={<OpenInNewIcon sx={{ fontSize: "14px !important" }} />}
          href={batch.google_sheet_url}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            fontWeight: 600,
            fontSize: "0.75rem",
            textTransform: "none",
            p: "2px 6px",
          }}
        >
          Google Sheet
        </Button>
      </Box>
    )}
  </>
);

export default BatchStats;
